module.exports = __webpack_public_path__ + "img/Contact-info.f4513e3d.svg";